import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/Mateja3m'
      className='link footer__link'
    >
      Created By Milan Matejic
    </a>
  </footer>
)

export default Footer
